export default "__VITE_ASSET__BLqrCVsH__"